import React from "react";
import {Avatar, Button, Menu, MenuItem} from "@mui/material";
import {logout} from "../../pages/logout/LogoutPage";
import {AccountCircle} from "@mui/icons-material";
import {GlobalState} from "../../global/GlobalState";
import {login} from "../../pages/login/LoginPage";
import {translateFunction} from "../../localization/TranslationService";

const translate = translateFunction();

export function AccountMenu() {
	const userSession = GlobalState.userSession;
	
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	
	const icon = userSession?.user.avatarUrl != null
		? <Avatar
			alt={userSession.user.name} src={userSession.user.avatarUrl}
			sx={{height: 24, width: 24}}
			imgProps={{
				referrerPolicy: "no-referrer"
			}}
		/>
		: <AccountCircle/>;
	
	return <div>
		<Button
			id="account-menu"
			endIcon={icon}
			aria-controls={open ? "account-menu" : undefined}
			aria-haspopup="true"
			aria-expanded={open ? "true" : undefined}
			onClick={handleClick}
			style={{
				color: "inherit",
			}}>{translate("User")}</Button>
		<Menu
			anchorEl={anchorEl}
			open={open}
			onClose={handleClose}
			MenuListProps={{
				"aria-labelledby": "account-button",
			}}
		>
			<MenuItem onClick={openSettingsPage}>{translate("Settings")}</MenuItem>
			{userSession == null
				? <MenuItem onClick={login}>{translate("Login")}</MenuItem>
				: <MenuItem onClick={logout}>{translate("Logout")}</MenuItem>}
		</Menu>
	</div>;
}

function openSettingsPage() {
	window.location.href = "/settings";
}
